import React from "react";

const PersonalInfoPage = () => {
  return <div>PersonalInfoPage</div>;
};

export default PersonalInfoPage;
